import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Signal, signal } from '@angular/core';
import { MapsFieldComponent } from "../../../../shared/components/fields/maps-field/maps-field.component";
import { toSignal } from '@angular/core/rxjs-interop';
import { DashboardService } from '../../dashboard.service';
import { HttpParams } from '@angular/common/http';
import { IMapDashboard, IMapPuntiCoordinate } from '../../models/dashboard-card.model';
import { IPuntoCampionamento } from 'src/app/modules/punti-campionamento/punti-campionamento.model';
import { ApiService } from 'src/app/core/services/api.service';
import { QueryService } from 'src/app/core/services/query.service';
import { FormGroup } from '@angular/forms';
import { MapsFieldDashboardComponent } from "../maps-field-dashboard/maps-field-dashboard.component";
import { CommonModule } from '@angular/common';
import { map } from 'rxjs';
@Component({
    selector: 'app-dashboard-map',
    standalone: true,
    templateUrl: './dashboard-map.component.html',
    styleUrl: './dashboard-map.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MapsFieldComponent, MapsFieldDashboardComponent,CommonModule]
})
export class DashboardMapComponent<TData = any> {

  datiCoordinate:IMapPuntiCoordinate[] | any;

  objMapArray:any=[]
  checkData:boolean=false
  objMap={
  "altitude" : 208.7472076416016,
  "lat": 42.25028518357651,
  "lng": 12.36961841583252,
  }
  optionsMap: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    tilt: 0,
    clickableIcons: false,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    zoomControl: true,
    scrollwheel: false,
    gestureHandling: 'auto',
    keyboardShortcuts: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
  }

  constructor(
    private readonly dashboardService: DashboardService,
    private api: ApiService,
    private cdr : ChangeDetectorRef
  ){}
  ngOnInit(): void {
    this.dashboardService.get().pipe(
      map((event:IMapPuntiCoordinate)=>{
        this.datiCoordinate=event
        if(this.datiCoordinate){
          this.datiCoordinate.forEach((element:any) => {
            if(element){
              this.objMapArray.push({
                "lat": element?.lat,
                "lng": element?.lon,
                "uuid": element?.uuid,
                "comune":element?.comune,
                "tipoPuntoCampionamento":element?.tipoPuntoCampionamento
              })
            }
          });
        } 
        this.checkData=true
        this.cdr.detectChanges()
      })
    ).subscribe();
  }
  checkEmptyArray(el:any){
    return el.length != 0
  }


}
